import React from 'react';
import { TransactionStatusChip } from 'app/pages/overview/tabs/transactions/TransactionStatusChip';
import { HighnoteTransactionEvent, WorkflowStatus } from 'API';
import { labelKeyFor, resolveStatus, StatusKey } from 'util/workflowStatus';
import { useApprovalLevels } from 'app/hooks/transactions/useApprovalLevels';
import { useGroupApprovalsEnabled } from 'app/hooks/transactions/useGroupApprovalsEnabled';
import { useUserRole } from 'app/hooks/useUserRole';

export enum FlexCodeTransactionStatus {
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REVIEWED = 'REVIEWED',
  APPROVED = 'APPROVED',
}

type FlexStatusArgs = {
  status?: FlexCodeTransactionStatus | null;
  workflowStatus?: WorkflowStatus | null;
  transaction?: HighnoteTransactionEvent | null;
  approvalLevels?: number;
};

export const getFlexcodeStatusText = ({
  status,
  workflowStatus,
  transaction,
  approvalLevels,
}: FlexStatusArgs): StatusKey =>
  resolveStatus({
    transaction: {
      ...(transaction ?? {}),
      ...(status !== undefined ? { flexCodeTransactionStatus: status } : {}),
      ...(workflowStatus !== undefined ? { workflowStatus } : {}),
    } as HighnoteTransactionEvent,
    accountType: 'flex',
    approvalLevels,
  }) ?? 'needsReview';

export const FlexcodeStatusChip: React.FC<FlexStatusArgs> = (props) => {
  const approvalLevels = useApprovalLevels('flex');
  const groupApprovalsEnabled = useGroupApprovalsEnabled();
  const { canAccessTransactions } = useUserRole();
  const status = getFlexcodeStatusText({ ...props, approvalLevels });
  return (
    <TransactionStatusChip
      status={status}
      labelKey={labelKeyFor(status, 'flex', approvalLevels, groupApprovalsEnabled)}
      waitingOnTransactionId={canAccessTransactions ? props.transaction?.id : undefined}
    />
  );
};
